import { VENDOR_DOWNLOAD_LIST, VENDOR_DOWNLOAD_LIST_SUCCESS, VENDOR_DOWNLOAD_LIST_ERROR, VENDOR_DOWNLOAD_LIST_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VendorDownloadsList = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_DOWNLOAD_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_DOWNLOAD_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VENDOR_DOWNLOAD_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VENDOR_DOWNLOAD_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorDownloadsList;
